import * as React from 'react';

import { branch, compose } from 'recompose';

import Alice from 'bundles/alice/components/Alice';
import { XDP } from 'bundles/alice/constants/AliceContextType';
import withAliceNotification from 'bundles/alice/lib/withAliceNotification';
import AlicePageviewEvent from 'bundles/alice/models/AlicePageviewEvent';
import { useCoursePageData } from 'bundles/unified-description-page-common/contexts/consumer/ConsumerBffCourseContext';
import { useSpecializationPageData } from 'bundles/unified-description-page-common/contexts/consumer/ConsumerBffSpecializationContext';

type PropsFromProvider = {
  s12nId?: string;
  courseId?: string;
};

type ChildProps = { children: React.ReactNode };

const AliceHocInner = ({ children }: ChildProps) => {
  return (
    <React.Fragment>
      <Alice />
      {children}
    </React.Fragment>
  );
};

const AliceHoc = compose<ChildProps, PropsFromProvider>(
  branch(
    ({ s12nId, courseId }: PropsFromProvider) => {
      return !!s12nId || !!courseId;
    },
    withAliceNotification(
      () => {
        return new AlicePageviewEvent({ contextType: XDP });
      },
      ({ s12nId, courseId }: PropsFromProvider) => {
        if (s12nId) {
          return {
            // eslint-disable-next-line camelcase
            specialization_id: s12nId,
          };
        } else {
          // eslint-disable-next-line camelcase
          return { course_id: courseId };
        }
      }
    )
  )
)(AliceHocInner);

const AliceProvider = ({ children }: ChildProps) => {
  const s12nPageData = useSpecializationPageData();
  const coursePageData = useCoursePageData();

  return (
    <AliceHoc courseId={coursePageData?.id} s12nId={s12nPageData?.id}>
      {children}
    </AliceHoc>
  );
};

export default AliceProvider;
